import { CharlieSpinner } from '@ver.id/libs.ui.charlie';
import HostedStatusBlock from './StatusBlock';

type Props = {
  title: string;
  subtitle?: string;
};

export default function HostedLoadingState({ title, subtitle }: Props) {
  return (
    <HostedStatusBlock
      visual={<CharlieSpinner className="text-muted-foreground" />}
      title={title}
      subtitle={subtitle}
    />
  );
}
